/* eslint-disable @typescript-eslint/no-misused-promises */
import { NetworkFactory, NetworkResponse } from './network/network-factory';

const networkService = NetworkFactory.create();

interface RegisterUserEmailOnlyProps {
  checkForService?: boolean;
  data: {
    bounceDetection: boolean;
    discoveryPage?: boolean;
    email: string;
    name?: string;
    password?: string;
    finalizeNow: boolean;
    seenTos: boolean;
  };
  urlLangPrefix: string;
  productUrl: string;
  product: string;
}

export enum EmailOnlyRegistrationStatus {
  Success,
  AlreadyRegistered
}

interface RegisterUserEmailOnlyResponse {
  isEnterpriseUser: boolean;
  redirectUrl: string;
  response: any;
  registrationStatus: EmailOnlyRegistrationStatus;
}

interface RegisterFullFieldsProps {
  data: {
    bounceDetection: boolean;
    discoveryPage?: boolean;
    email: string;
    password: string;
    name: string;
    finalizeNow: boolean;
    seenTos: boolean;
  };
  urlLangPrefix: string;
  productUrl: string;
  product: string;
}

interface RegisterFullFieldsResponse {
  redirectUrl: string;
  response: NetworkResponse;
}

const registerUserEmailOnly = ({
  data,
  urlLangPrefix,
  productUrl,
  product,
  checkForService
}: RegisterUserEmailOnlyProps): Promise<RegisterUserEmailOnlyResponse> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let isEnterpriseUser = false;
    let redirectUrl = '';
    let registrationStatus = EmailOnlyRegistrationStatus.Success;
    try {
      const response = await networkService.post(
        `${productUrl}/${urlLangPrefix}registerForm`,
        {
          data: {
            ...data,
            product: product
          },
          headers: { 'Content-Type': 'application/json; charset=UTF-8' },
          config: { withCredentials: true }
        }
      );
      if (response.status === 200) {
        redirectUrl = response.data.redirect;
        if (redirectUrl.includes('login')) {
          registrationStatus = EmailOnlyRegistrationStatus.AlreadyRegistered;
        }
        if (checkForService) {
          const bootstrapResponse = await networkService.get('/bootstrap');
          const ssoResponse = await networkService.get(
            `${bootstrapResponse.data.services.users}/accounts/sso`,
            {
              params: {
                email: data.email,
                product: product
              }
            }
          );
          const ssoPolicy = ssoResponse.data;
          // regular registration or enterprise
          isEnterpriseUser = ssoPolicy.type !== 'password';
          redirectUrl = ssoPolicy.url;
        } else {
          redirectUrl = response.data.redirect;
        }
        resolve({
          isEnterpriseUser,
          redirectUrl,
          response,
          registrationStatus
        });
      } else {
        reject(`Error: Response status - ${response.status}`);
      }
    } catch (error) {
      reject(error);
    }
  });
};

const registerFullFields = ({
  data,
  urlLangPrefix,
  productUrl,
  product
}: RegisterFullFieldsProps): Promise<RegisterFullFieldsResponse> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let redirectUrl = '';
    try {
      const response: NetworkResponse = await networkService.post(
        `${productUrl}/${urlLangPrefix}registerForm`,
        {
          data,
          headers: { 'Content-Type': 'application/json; charset=UTF-8' },
          config: { withCredentials: true, fullFields: true, product: product }
        }
      );
      if (response.status >= 200 && response.status < 300) {
        redirectUrl = response.data.redirect;
        resolve({ redirectUrl, response });
      } else {
        reject(`Error: Response status - ${response.status}`);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export { registerUserEmailOnly, registerFullFields };
